import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tab, Tabs } from '@blueprintjs/core';
import { useFormikContext } from 'formik';
import { CheckBoxCell } from '../../../elements/CheckBoxCell';
import IsotopesViewer from '../../../elements/IsotopesViewer';
import Label from '../../../elements/Label';
import ReactTable from '../../../elements/ReactTable/ReactTable';
import FormikCheckBox from '../../../elements/formik/FormikCheckBox';
function OnLoadProcessingTabContent() {
    const { values } = useFormikContext();
    const isExperimentalFeatures = values.display?.general?.experimentalFeatures?.display || false;
    return (_jsxs("div", { children: [_jsx(Label, { title: "Enable auto processing on load", style: { wrapper: { padding: '10px 0' } }, children: _jsx(FormikCheckBox, { name: "onLoadProcessing.autoProcessing" }) }), isExperimentalFeatures && _jsx(AutoProcessingFilters, {})] }));
}
function AutoProcessingFilters() {
    const { values } = useFormikContext();
    const autoProcessingFilters = values?.onLoadProcessing?.filters || {};
    const tabItems = Object.keys(autoProcessingFilters).map((nucleus) => ({
        id: nucleus,
        title: _jsx(IsotopesViewer, { value: nucleus }),
        content: (_jsx(FiltersTable, { data: autoProcessingFilters[nucleus], nucleus: nucleus })),
    }));
    return (_jsx("div", { style: { width: '100%', overflow: 'hidden' }, children: _jsx(Tabs, { children: tabItems.map((item) => (_jsx(Tab, { id: item.id, title: item.title, panel: item.content }, item.id))) }) }));
}
function FiltersTable({ data, nucleus }) {
    const COLUMNS = [
        {
            index: 1,
            Header: '#',
            accessor: (_, index) => index + 1,
        },
        {
            index: 1,
            Header: 'Filter',
            accessor: 'label',
            style: { width: '60%' },
        },
        {
            index: 2,
            Header: 'Enable',
            Cell: ({ row }) => (_jsx(CheckBoxCell, { name: `onLoadProcessing.filters.${nucleus}.${row.index}.flag`, defaultValue: false })),
        },
    ];
    return _jsx(ReactTable, { columns: COLUMNS, data: data });
}
export default OnLoadProcessingTabContent;
